"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const Icon_1 = require("../Icon");
const ContextMenu_1 = __importDefault(require("../ContextMenu/ContextMenu"));
const Button_1 = __importStar(require("../Button/Button"));
const utils_1 = require("../utils");
const BaseDropdownButton = styled_1.default(Button_1.default)(({ isOpen, theme }) => (Object.assign({ paddingRight: 0, marginRight: 0 }, (isOpen && {
    borderBottom: `1px solid ${theme.color.white}`,
    zIndex: theme.zIndex.selectOptions + 2,
}))));
const CaretContainer = styled_1.default.div(({ isOpen, theme, color }) => {
    const { background: backgroundColor, border: borderColor } = Button_1.makeColors(theme, color);
    return {
        width: 36,
        marginLeft: theme.space.content,
        borderLeft: isOpen
            ? "none"
            : `1px solid ${utils_1.isWhite(backgroundColor) ? borderColor : utils_1.setAlpha(0.5)(theme.color.white)}`,
    };
});
const ItemWithChevron = styled_1.default.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const ContextMenuWithBorder = styled_1.default(ContextMenu_1.default)(({ theme }) => ({
    "& div[role='listbox']": {
        border: `1px solid ${theme.color.border.disabled}`,
        transform: "translate(0, -1px)",
    },
}));
const DropdownButton = (_a) => {
    var { items, onItemClick, color = "primary", align, children } = _a, props = __rest(_a, ["items", "onItemClick", "color", "align", "children"]);
    // Dropdown buttons always have right chevrons for every item. These are added automatically.
    const itemsWithCarets = items.map(item => {
        const itemAsObject = typeof item === "string" ? { label: item } : item;
        return Object.assign({}, itemAsObject, { label: (React.createElement(ItemWithChevron, null,
                itemAsObject.label,
                React.createElement(Icon_1.ChevronRightIcon, { size: 8 }))) });
    });
    return (React.createElement(ContextMenuWithBorder, Object.assign({}, props, { anchored: true, onClick: onItemClick, iconLocation: "right", items: itemsWithCarets, align: align }), isOpen => {
        return (React.createElement(BaseDropdownButton, Object.assign({}, props, { color: isOpen ? "default" : color, textColor: isOpen ? "primary" : undefined, isOpen: isOpen }),
            children,
            React.createElement(CaretContainer, { isOpen: isOpen, color: color }, isOpen ? React.createElement(Icon_1.CaretUpIcon, { size: 8 }) : React.createElement(Icon_1.CaretDownIcon, { size: 8 }))));
    }));
};
exports.default = DropdownButton;
//# sourceMappingURL=DropdownButton.js.map